import { AppPage } from "models/AppPage";

interface UseTagRoutingReturn {
    getDisplayLabel: (page: AppPage, currentTag?: string) => string;
}

/**
 * Custom hook to handle tag-based routing display logic
 * Determines how navigation labels should be displayed based on current route
 */
export const useTagRouting = (isOnTagRoute: boolean): UseTagRoutingReturn => {
    /**
     * Get the display label for a navigation page
     * For tag routes on "콘텐츠 큐레이션", shows the tag name
     * Otherwise shows the original page label
     */
    const getDisplayLabel = (page: AppPage, currentTag?: string): string => {
        if (
            isOnTagRoute &&
            page.label === "콘텐츠 큐레이션" &&
            page.children &&
            currentTag
        ) {
            // Find the child that matches the current tag
            const matchingChild = page.children.find((child) =>
                child.href.includes(`tag=${currentTag}`)
            );
            const tagName = matchingChild ? matchingChild.label : currentTag;
            return `${tagName}`;
        }

        // Special case: rename "콘텐츠 큐레이션" to "카테고리"
        if (page.label === "콘텐츠 큐레이션") {
            return "카테고리";
        }

        return page.label;
    };

    return {
        getDisplayLabel
    };
};
